import { render, staticRenderFns } from "./display-controller.vue?vue&type=template&id=3d984b5c&scoped=true&"
import script from "./display-controller.vue?vue&type=script&lang=js&"
export * from "./display-controller.vue?vue&type=script&lang=js&"
import style0 from "./display-controller.vue?vue&type=style&index=0&id=3d984b5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d984b5c",
  null
  
)

export default component.exports